import { Link } from "wouter";
import { m, useReducedMotion } from "framer-motion";
import { BrandWordmark } from "../BrandWordmark";

const linkClass =
  "inline-flex min-h-[44px] items-center rounded-md px-2 outline-none transition-[color,transform] duration-200 hover:translate-x-0.5 hover:text-neutral-900 focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2";

/** In-page anchors glide to their scene (see stage/SnapStage); the rest are routes. */
const SCENE_LINKS = [
  { href: "#features", label: "What's on the list" },
  { href: "#security", label: "Privacy" },
  { href: "#faq", label: "FAQ" },
  { href: "#feedback", label: "Feedback" },
];

const ROUTE_LINKS = [
  { href: "/login", label: "Sign in" },
  { href: "/register", label: "Create account" },
  { href: "/terms", label: "Terms" },
  { href: "/privacy", label: "Privacy policy" },
];

/**
 * Site footer. On the landing page it sits at the bottom of the last scene
 * (so the final snap point still reaches it) and fades up as that scene's
 * closing step, via `data-fx="footer"`.
 */
export function Footer() {
  const reduce = useReducedMotion();

  return (
    <footer data-fx="footer" className="relative bg-white">
      {/* Low-opacity sky → indigo gradient hairline */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-sky-300/40 via-indigo-300/60 to-sky-300/40"
      />
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-6 py-5 text-sm text-neutral-500 sm:gap-4 sm:py-6 md:flex-row md:items-center md:justify-between">
        <div>
          <m.span
            className="inline-flex"
            whileHover={reduce ? undefined : { scale: [1, 1.06, 0.98, 1.03, 1] }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
          >
            <BrandWordmark className="h-6" />
          </m.span>
          <p className="mt-1">Your family's care info, shared safely.</p>
        </div>
        <nav aria-label="Footer" className="-mx-2 flex flex-wrap gap-x-1">
          {SCENE_LINKS.map((l) => (
            <a key={l.href} href={l.href} className={linkClass}>
              {l.label}
            </a>
          ))}
          {ROUTE_LINKS.map((l) => (
            <Link key={l.href} href={l.href} className={linkClass}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
